import React from "react";
import { Spinner } from "reactstrap";
import PropTypes from "prop-types";
import "./UISpinner.css";

function UISpinner({ text = "Loading...", ...props }) {
	return (
		<div className="spinner-box d-flex flex-column justify-content-center align-items-center">
			<Spinner {...props} />
			{text && <p className="mt-3 text-muted small">{text}</p>}
		</div>
	);
}

UISpinner.propTypes = {
	text: PropTypes.string,
};

export default UISpinner;
